import { render, staticRenderFns } from "./DatePickerComponent.vue?vue&type=template&id=c0037c1c&scoped=true&"
import script from "./DatePickerComponent.vue?vue&type=script&lang=js&"
export * from "./DatePickerComponent.vue?vue&type=script&lang=js&"
import style0 from "./DatePickerComponent.vue?vue&type=style&index=0&id=c0037c1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0037c1c",
  null
  
)

export default component.exports